import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

const Keyboard = ({ guessedLetters, onLetterClick, disabled }) => {
  const { language } = useLanguage();

  const rows =
    language === "de"
      ? ["QWERTZUIOP", "ASDFGHJKLÄÖÜ", "YXCVBNM"]
      : ["QWERTYUIOP", "ASDFGHJKL", "ZXCVBNM"];

  const getButtonClass = (letter) => {
    if (!guessedLetters.has(letter)) {
      return "letter-button";
    }

    // For now, we'll use a neutral disabled state
    // In a more advanced version, you could track correct/incorrect guesses
    return "letter-button disabled";
  };

  return (
    <div className="keyboard">
      {rows.map((row) => (
        <div key={row} className="keyboard-row">
          {row.split("").map((letter) => (
            <button
              key={letter}
              className={getButtonClass(letter)}
              onClick={() => onLetterClick(letter)}
              disabled={guessedLetters.has(letter) || disabled}
            >
              {letter}
            </button>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Keyboard;
